import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch } from "../../Util/axios_helper";

const initialState = {
  inquiryThankyou: null,
  inquiryThankyouLoaded: false,
  eventType: [],
  eventTypeLoaded: false,
  refresh: 0,
  setTimeValue: 0,
  timeoutRefresh: false,
  settingTimeValue: {},
  settingTimeValueRefresh: false,
};

export const getInquiryThankyou = createAsyncThunk(
  "getInquiryThankyou",
  async (type) => {
    return await fetch(`Configuration/GetSettingValue?SettingName=${type}`);
  }
);

export const getClusterTypes = createAsyncThunk("getEventTypes", async () => {
  return await fetch("Configuration/GetClusterTypes");
});

export const SaveTimeOut = createAsyncThunk("SaveTimeOut", async (obj) => {
  return await fetch(
    `Configuration/SaveTimeOut?Id=${obj.intialId}&obj=${obj.timeValue}&SavedBy=${obj.SavedBy}`,
    true,
    false,
    false,
    true
  );
});

export const GetTimeOut = createAsyncThunk("GetTimeOut", async () => {
  return await fetch(`Configuration/GetInquiryTimeOut`);
});

const appConfigSlice = createSlice({
  name: "AppConfig",
  initialState: initialState,
  reducers: {
    onRefresh: (state) => {
      state.refresh = state.refresh + 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getInquiryThankyou.pending, (state) => {
      state.inquiryThankyouLoaded = false;
    });

    builder.addCase(getInquiryThankyou.fulfilled, (state, data) => {
      state.inquiryThankyouLoaded = true;
      state.inquiryThankyou = data.payload;
    });

    builder.addCase(getInquiryThankyou.rejected, (state, data) => {
      state.inquiryThankyouLoaded = true;
      state.inquiryThankyou = null;
    });

    builder.addCase(getClusterTypes.pending, (state) => {
      state.eventTypeLoaded = false;
    });

    builder.addCase(getClusterTypes.fulfilled, (state, data) => {
      state.eventType = data.payload;
      state.eventTypeLoaded = true;
    });

    builder.addCase(getClusterTypes.rejected, (state) => {
      state.eventType = [];
      state.eventTypeLoaded = true;
    });

    builder.addCase(SaveTimeOut.pending, (state) => {
      state.timeoutRefresh = false;
    });

    builder.addCase(SaveTimeOut.fulfilled, (state, data) => {
      state.setTimeValue = data.payload;
      state.timeoutRefresh = true;
    });

    builder.addCase(SaveTimeOut.rejected, (state) => {
      state.setTimeValue = 0;
      state.timeoutRefresh = true;
    });

    builder.addCase(GetTimeOut.pending, (state) => {
      state.settingTimeValueRefresh = false;
    });

    builder.addCase(GetTimeOut.fulfilled, (state, data) => {
      state.settingTimeValue = data.payload;
      state.settingTimeValueRefresh = true;
    });

    builder.addCase(GetTimeOut.rejected, (state) => {
      state.settingTimeValue = null;
      state.settingTimeValueRefresh = true;
    });
  },
});

export const { onRefresh } = appConfigSlice.actions;
export default appConfigSlice.reducer;
